import { render, staticRenderFns } from "./CustomFieldBuilder.vue?vue&type=template&id=27249e17&scoped=true"
import script from "./CustomFieldBuilder.vue?vue&type=script&lang=js"
export * from "./CustomFieldBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27249e17",
  null
  
)

export default component.exports